import React, { useEffect, useState } from 'react';
import { Add, Remove } from '@material-ui/icons';

const accordionStyles = `
.accordion {
  width: 100%;
  border-bottom: 1px solid #ccc;
}

.accordion-item {
  border-top: 1px solid #ccc;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  cursor: pointer;
}

.accordion-title {
  font-weight: 400;
  font-size: 24px;
  margin : 10px 0;
}

.accordion-icon {
  font-size: 1.2em;
}

.accordion-content {
  padding: 10px;
  background-color: #fff;
}
.color-black {
    color: #5e5e5e
}
.color-blue {
    color: #066fef
}
`;


function AccordionItem({ title, content, isExpanded, onToggle }) {
    return (
        <div className="accordion-item">
            <div className="accordion-header" onClick={onToggle}>
                <h4 className={`accordion-title ${isExpanded ? 'color-blue' : 'color-black'}`}>{title}</h4>
                <span className="accordion-icon">{isExpanded ? <Remove /> : <Add />}</span>
            </div>
            {isExpanded && (
                <div className="accordion-content">
                    {content.map((item, index) => (
                        <p key={index}>{item}</p>
                    ))}
                </div>
            )}
        </div>
    );
}

const SimpleAccordion = ({ name }) => {
    const [expandedItems, setExpandedItems] = useState([]); // Lưu trữ một mảng các tiêu đề đang mở

    const handleToggle = (title) => {
        setExpandedItems((prevExpandedItems) => {
            const isCurrentlyExpanded = prevExpandedItems.includes(title);
            if (isCurrentlyExpanded) {
                return prevExpandedItems.filter((item) => item !== title);
            } else {
                return [...prevExpandedItems, title];
            }
        });
    };

    const [accordionData, setAccordionData] = useState([]);
    const teritoryTitaniumX = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Xăng 1.5L EcoBoost tăng áp, i4; Phun xăng trực tiếp',
                'Công suất cực đại: 160 (118 kW) / 5.400 - 5.700 rpm',
                'Mô men xoắn cực đại: 248Nm / 1500-3500 rpm',
                'Số tự động 7 cấp',
                'Chế độ lái tùy chọn',
                'Trợ lực lái điện',
            ],
        },
        {
            title: 'Kích thước',
            content: [
                'Dài x Rộng x Cao (mm): 4.685 x 1.935 x 1.706',
                'Khoảng sáng gầm xe (mm): 190',
                'Chiều dài cơ sở (mm): 2726',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Dẫn động một cầu / 4x2'
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 19 inch'
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Bảng đồng hồ tốc độ 12.3 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
                'Hệ thống lọc không khí cao cấp'
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình giải trí trung tâm cảm ứng 12.3 inch',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
                'Hệ thống âm thanh 8 loa'
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế da cao cấp có thông gió hàng ghế trước',
                'Ghế lái chỉnh điện 10 hướng',
                'Ghế phụ chỉnh điện 4 hướng'
            ],
        },
        {
            title: 'Các trang bị khác',
            content: [
                '06 túi khí',
                'Camera 360 toàn cảnh',
                'Hệ thống Cảnh báo lệch làn (LKA) và hỗ trợ duy trì làn đường (LDW)',
                'Hệ thống Cảnh báo va chạm và hỗ trợ phanh khẩn cấp khi gặp chướng ngại vật phía trước (FCW & AEB)',
                'Hệ thống hỗ trợ đỗ xe',
                'Hệ thống cảnh báo điểm mù kết hợp Cảnh báo xe cắt ngang',
                'Hệ thống Kiểm soát hành trình thích ứng',
                'Hệ thống Kiểm soát áp suất lốp TPMS',
                'Hệ thống hỗ trợ đổ đèo',
                'Khởi động từ xa',
                'Đèn trang trí nội thất đa màu',
                'Cửa hậu đóng/ mở điện',
                'Gương chiếu hậu trong: Gương điện tử với Camera tích hợp'
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp:  7,40 (L/100km)',
                'Chu trình đô thị cơ bản: 9,62 (L/100km)',
                'Chu trình đô thị phụ: 6,13 (L/100km)'
            ],
        },
    ]
    const teritorySport = [
        {
            title: 'Động cơ xe & Hộp số',
            content: [
                '1.5L Ecoboost',
                '118 kW / 5.400 - 5.700 rpm',
                '248 Nm / 1.500 - 3.500 rpm',
                'Số tự động 7 cấp điện tử',
                'Chế độ lái tùy chọn',
                'Trợ lực lái điện',
            ],
        },
        {
            title: 'Kích thước',
            content: [
                'Dài x Rộng x Cao (mm): 4.630 x 1.935 x 1.706',
                'Khoảng sáng gầm xe (mm): 190',
                'Chiều dài cơ sở (mm): 2726',
            ],
        },
        {
            title: 'Hệ thống dẫn động của xe',
            content: [
                'Dẫn động một cầu / 4x2',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 18 inch',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Bảng đồng hồ tốc độ 7 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
                'Hệ thống lọc không khí cao cấp',
            ],
        },
        {
            title: 'Hệ thống giải trí trên ô tô',
            content: [
                'Màn hình giải trí trung tâm cảm ứng 12.3 inch',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
                'Hệ thống âm thanh 8 loa',
            ],
        },
        {
            title: 'Ghế xe',
            content: [
                'Ghế Da cao cấp',
                'Ghế lái chỉnh điện 10 hướng',
            ],
        },
        {
            title: 'Các trang bị khác',
            content: [
                '06 túi khí',
                'Camera 360 toàn cảnh',
                'Hệ thống Cảnh báo lệch làn (LKA) và hỗ trợ duy trì làn đường (LDW)',
                'Hệ thống Cảnh báo va chạm và hỗ trợ phanh khẩn cấp khi gặp chướng ngại vật phía trước (FCW & AEB)',
                'Hệ thống hỗ trợ đỗ xe',
                'Hệ thống cảnh báo điểm mù kết hợp Cảnh báo xe cắt ngang',
                'Hệ thống Kiểm soát hành trình thích ứng',
                'Hệ thống Kiểm soát áp suất lốp TPMS',
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 7.67 (L/100km)',
                'Chu trình đô thị cơ bản: 9.62 (L/100km)',
                'Chu trình đô thị phụ: 6.52 (L/100km)',
            ],
        },
    ];
    const teritoryTitanium = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Xăng 1.5L EcoBoost tăng áp, I4; Phun xăng trực tiếp',
                'Công suất cực đại: 160 (118 kW) / 5.400~ 5.700 rpm',
                'Mô men xoắn cực đại: 248Nm / 1500-3500 rpm',
                'Số tự động 7 cấp',
                'Chế độ lái tùy chọn',
                'Trợ lực lái điện',
            ],
        },
        {
            title: 'Kích thước',
            content: [
                'Dài x Rộng x Cao (mm): 4.685 x 1.935 x 1.706',
                'Khoảng sáng gầm xe (mm): 190',
                'Chiều dài cơ sở (mm): 2726',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Dẫn động một cầu / 4x2',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 18 inch',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Bảng đồng hồ tốc độ 7 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình giải trí trung tâm cảm ứng 12.3 inch',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
                'Hệ thống âm thanh 8 loa với hiệu ứng âm thanh vòm',
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế Da cao cấp',
                'Ghế lái chỉnh điện 10 hướng',
                'Ghế phụ chỉnh điện 4 hướng'
            ],
        },
        {
            title: 'Các trang bị khác',
            content: [
                '06 túi khí',
                'Camera 360 toàn cảnh',
                'Hệ thống Cảnh báo lệch làn (LKA) và hỗ trợ duy trì làn đường (LDW)',
                'Hệ thống Cảnh báo va chạm và hỗ trợ phanh khẩn cấp khi gặp chướng ngại vật phía trước (FCW & AEB)',
                'Hệ thống hỗ trợ đỗ xe',
                'Hệ thống cảnh báo điểm mù kết hợp Cảnh báo xe cắt ngang',
                'Hệ thống Kiểm soát hành trình thích ứng',
                'Hệ thống Kiểm soát áp suất lốp TPMS',
                'Hệ thống hỗ trợ đổ đèo',
                'Khởi động từ xa',
                'Gương chiếu hậu trong: tự động chống chói'
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 7,40 (L/100km)',
                'Chu trình đô thị cơ bản: 9,62 (L/100km)',
                'Chu trình đô thị phụ: 6,13 (L/100km)',
            ],
        },
    ];
    const teritoryTrend = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Xăng 1.5L EcoBoost tăng áp, I4; Phun xăng trực tiếp',
                'Công suất cực đại: 160 (118 kW) / 5.400~ 5.700 rpm',
                'Mô men xoắn cực đại: 248Nm / 1500-3500 rpm',
                'Số tự động 7 cấp',
                'Chế độ lái tùy chọn',
                'Trợ lực lái điện',
            ],
        },
        {
            title: 'Kích thước',
            content: [
                'Dài x Rộng x Cao (mm): 4.685 x 1.935 x 1.706',
                'Khoảng sáng gầm xe (mm): 190',
                'Chiều dài cơ sở (mm): 2726',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Dẫn động một cầu / 4x2',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 18 inch',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Bảng đồng hồ tốc độ 7 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình giải trí trung tâm cảm ứng 12.3 inch',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Hệ thống âm thanh 6 loa',
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế da Vinyl',
                'Ghế lái chỉnh điện 10 hướng',
            ],
        },
        {
            title: 'Các trang bị khác',
            content: [
                '04 túi khí',
                'Camera lùi',
                'Hệ thống Kiểm soát hành trình',
                'Hệ thống Kiểm soát áp suất lốp TPMS',
                'Cảm biến sau hỗ trợ đỗ xe',
                'Hệ thống hỗ trợ đổ đèo',
                'Khởi động từ xa'
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 7,40 (L/100km)',
                'Chu trình đô thị cơ bản: 9,62 (L/100km)',
                'Chu trình đô thị phụ: 6,13 (L/100km)',
            ],
        },
    ];
    const everestPlatinum = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Bi Turbo Diesel 2.0L i4 TDCi',
                '209.8 (154.3 kW)/3750',
                '500Nm / 1750-2000 rpm',
                'Số tự động 10 cấp điện tử',
                'Phanh tay điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Hai cầu chủ động 4x4',
            ],
        },
        {
            title: 'Lưới tản nhiệt và Cụm Đèn pha phía trước',
            content: [
                'Lưới tản nhiệt mạ crôm mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED Matrix hình chữ C tự động bật đèn, tự động bật đèn chiếu góc',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 20 inch với thiết kế đa chấu',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Cụm đồng hồ kỹ thuật số 12 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình LED dọc 12.4 inch trang bị SYNC® 4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế da & Vinyl tổng hợp',
                'Ghế lái và ghế khách chỉnh điện 10 hướng có nhớ vị trí ghế lái',
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 8,0 (L/100km)',
                'Chu trình đô thị cơ bản: 9,6 (L/100km)',
                'Chu trình đô thị phụ: 7,1 (L/100km)',
            ],
        },
    ];
    const everesttiatinum = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Động cơ Diesel 2.0L Bi-turbo i4 TDCi',
                'Công suất tối đa 209.8 (154.3 kW) / 3750',
                'Mô-men xoắn tối đa 500 / 1750-2000',
                'Có Hệ thống kiểm soát đường địa hình',
                'Số tự động 10 cấp điện tử',
                'Phanh tay điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Hai cầu chủ động 4x4',
            ],
        },
        {
            title: 'Lưới tản nhiệt và Cụm Đèn pha phía trước',
            content: [
                'Lưới tản nhiệt mạ crôm mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED Matrix hình chữ C tự động bật đèn, tự động bật đèn chiếu góc',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 20 inch với thiết kế đa chấu',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Cụm đồng hồ kỹ thuật số 12,4 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình TFT cảm ứng 12 inch trang bị SYNC® 4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế da & Vinyl tổng hợp',
                'Ghế lái và ghế khách chỉnh điện 10 hướng',
                'Hàng ghế thứ ba gập điện',
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 8,43 (L/100km)',
                'Chu trình đô thị cơ bản: 10,09 (L/100km)',
                'Chu trình đô thị phụ: 7,45 (L/100km)',
            ],
        },

    ];
    const everesttiatinum20 = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Động cơ Turbo Diesel 2.0L i4 TDCi',
                'Công suất tối đa 170 (125 KW) / 3500',
                'Mô-men xoắn tối đa 405 / 1750-2500',
                'Số tự động 6 cấp điện tử',
                'Phanh tay điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Một cầu chủ động 4x2',
            ],
        },
        {
            title: 'Lưới tản nhiệt và Cụm Đèn pha phía trước',
            content: [
                'Lưới tản nhiệt mạ crôm mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED Matrix hình chữ C tự động bật đèn, tự động bật đèn chiếu góc',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 20 inch với thiết kế đa chấu',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Cụm đồng hồ kỹ thuật số 12,4 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình TFT cảm ứng 12 inch trang bị SYNC® 4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế da & Vinyl tổng hợp',
                'Ghế lái và ghế khách chỉnh điện 10 hướng',
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 8,2 (L/100km)',
                'Chu trình đô thị cơ bản: 10,5 (L/100km)',
                'Chu trình đô thị phụ: 6.8 (L/100km)',
            ],
        },

    ];
    const everestSport = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Single Turbo Diesel 2.0L i4 TDCi',
                '170 (125 KW) / 3500',
                '405 Nm/ 1750-2500 rpm',
                'Số tự động 6 cấp',
                'Phanh tay điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Dẫn động một cầu',
            ],
        },
        {
            title: 'Lưới tản nhiệt và Đèn pha phía trước',
            content: [
                'Lưới tản nhiệt sơn đen mang ADN thiết kế đặc trưng Ford toàn cầu kết hợp cùng cụm đèn pha LED hình chữ C',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 20 inch màu đen bóng',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Cụm đồng hồ kỹ thuật số 8 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình LED dọc 10,1 inch với SYNC® 4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế da & Vinyl tổng hợp',
                'Ghế lái và ghế khách chỉnh điện 8 hướng',
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 8,56 (L/100km)',
                'Chu trình đô thị cơ bản: 11,08 (L/100km)',
                'Chu trình đô thị phụ: 7,09 (L/100km)',
            ],
        },
    ];
    const everestAmbiente = [
        {
            title: 'Động cơ & Hộp số',
            content: [
                'Single Turbo Diesel 2.0L i4 TDCi',
                '170 (125 KW) / 3500',
                '405 Nm/ 1750-2500 rpm',
                'Số tự động 6 cấp',
                'Phanh tay điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động',
            content: [
                'Dẫn động một cầu',
            ],
        },
        {
            title: 'Lưới tản nhiệt và Đèn pha phía trước',
            content: [
                'Lưới tản nhiệt mang ADN thiết kế đặc trưng Ford toàn cầu với đèn pha LED hình chữ C',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 18 inch màu Bạc Ánh Kim',
            ],
        },
        {
            title: 'Khoang lái',
            content: [
                'Cụm đồng hồ kỹ thuật số 8 inch',
                'Điều hoà nhiệt độ điều chỉnh tay',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống thông tin giải trí',
            content: [
                'Màn hình LED dọc 10,1 inch trang bị SYNC® 4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế ngồi',
            content: [
                'Ghế da & Vinyl tổng hợp',
                'Ghế lái chỉnh điện 8 hướng',
            ],
        },
        {
            title: 'Mức tiêu thụ nhiên liệu',
            content: [
                'Chu trình tổ hợp: 8,51 (L/100km)',
                'Chu trình đô thị cơ bản: 10,8 (L/100km)',
                'Chu trình đô thị phụ: 7,17 (L/100km)',
            ],
        },
    ];
    const rangerRaptor = [
        {
            title: 'Động cơ xe & Hộp số',
            content: [
                'Bi Turbo Diesel 2.0L i4 TDCi',
                '210 (154.5 KW) / 3750',
                '500Nm / 1750-2000 rpm',
                'Số tự động 10 cấp điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động của xe',
            content: [
                'Hai cầu chủ động toàn thời gian và bán thời gian',
            ],
        },
        {
            title: 'Lưới tản nhiệt & Cụm đèn pha phía trước xe',
            content: [
                'Lưới tản nhiệt mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED Matrix hình chữ C, tự động bật đèn, tự động bật đèn chiếu góc',
            ],
        },
        {
            title: 'Đèn sương mù',
            content: [], // Thông tin chi tiết nếu có
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 17 inch',
            ],
        },
        {
            title: 'Khoang lái xe',
            content: [
                'Cụm đồng hồ kỹ thuật số 12.4 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống giải trí trên ô tô',
            content: [
                'Màn hình LED dọc 12 inch trang bị SYNC®4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế xe',
            content: [
                'Ghế da cao cấp',
                'Ghế lái chỉnh điện 10 hướng',
            ],
        },
        {
            title: 'Thùng hàng phía sau & các trang bị khác của xe',
            content: [
                'Tích hợp bậc lên xuống thùng hàng',
                'Lót thùng hàng với ổ điện 12V và 230V (400WW)',
                'Nâng hạ thùng hàng sau có trợ lực',
                'Tích hợp tấm bảo vệ thành thùng hàng',
                'Thanh giá nóc và thanh Sportbar',
            ],
        },
    ];
    const rangerStormtrak = [
        {
            title: 'Động cơ xe & Hộp số',
            content: [
                'Bi Turbo Diesel 2.0L i4 TDCi',
                '210 (154.5 KW) / 3750',
                '500Nm / 1750-2000 rpm',
                'Số tự động 10 cấp điện tử',
                'Phanh tay điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động của xe',
            content: [
                'Dẫn động hai cầu chủ động',
            ],
        },
        {
            title: 'Lưới tản nhiệt & Cụm đèn pha phía trước xe',
            content: [
                'Lưới tản nhiệt mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED Matrix hình chữ C, tự động chống chói, tự động bật đèn chiếu góc, đèn trợ sáng',
                'Đèn sương mù',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 20 inch',
            ],
        },
        {
            title: 'Khoang lái xe',
            content: [
                'Cụm đồng hồ kỹ thuật số 12.4 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống giải trí trên ô tô',
            content: [
                'Màn hình LED dọc 12 inch trang bị SYNC®4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế xe',
            content: [
                'Ghế da Vinyl & da lộn',
                'Hàng ghế trước chỉnh điện 8 hướng',
            ],
        },
        {
            title: 'Thùng hàng phía sau & các trang bị khác của xe',
            content: [
                'Tích hợp bậc lên xuống thùng hàng',
                'Lót thùng hàng với ổ điện 12V và 230V (400WW)',
                'Nâng hạ thùng hàng sau có trợ lực',
                'Tích hợp tấm bảo vệ thành thùng hàng',
                'Hệ thống giá nóc và thanh thể thao linh hoạt đa năng',
            ],
        },
    ];
    const rangerWiltrak = [
        {
            title: 'Động cơ xe & Hộp số',
            content: [
                'Bi Turbo Diesel 2.0L i4 TDCi',
                '210 (154.5 KW) / 3750',
                '500Nm / 1750-2000 rpm',
                'Số tự động 10 cấp điện tử',
                'Phanh tay điện tử',
            ],
        },
        {
            title: 'Hệ thống dẫn động của xe',
            content: [
                'Dẫn động hai cầu chủ động',
            ],
        },
        {
            title: 'Lưới tản nhiệt & Cụm đèn pha phía trước xe',
            content: [
                'Lưới tản nhiệt mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED Matrix hình chữ C, tự động bật đèn, tự động bật đèn chiếu góc',
                'Đèn sương mù',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 18 inch',
            ],
        },
        {
            title: 'Khoang lái xe',
            content: [
                'Cụm đồng hồ kỹ thuật số 8 inch',
                'Điều hoà nhiệt độ tự động 2 vùng khí hậu',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống giải trí trên ô tô',
            content: [
                'Màn hình LED dọc 12 inch trang bị SYNC®4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế xe',
            content: [
                'Ghế da & Vinyl tổng hợp',
                'Ghế lái chỉnh điện 8 hướng',
            ],
        },
        {
            title: 'Thùng hàng phía sau & các trang bị khác của xe',
            content: [
                'Tích hợp bậc lên xuống thùng hàng',
                'Lót thùng hàng với ổ điện 12V và 230V (400WW)',
                'Nâng hạ thùng hàng sau có trợ lực',
                'Tích hợp tấm bảo vệ thành thùng hàng',
                'Thanh giá nóc và thanh Sportbar',
            ],
        },
    ];
    const rangerXlsPlus = [
        {
            title: 'Động cơ xe & Hộp số',
            content: [
                'Single Turbo Diesel 2.0L i4 TDCi',
                '170 (125 KW) / 3500',
                '405 Nm/ 1750-2500 rpm',
                'Số tự động 6 cấp hoặc 6 số tay',
            ],
        },
        {
            title: 'Hệ thống dẫn động của xe',
            content: [
                'Dẫn động hai cầu chủ động hoặc một cầu chủ động',
            ],
        },
        {
            title: 'Lưới tản nhiệt & Cụm đèn pha phía trước xe',
            content: [
                'Lưới tản nhiệt mạ crôm mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED hình chữ C',
                'Đèn sương mù',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 16 inch',
            ],
        },
        {
            title: 'Khoang lái xe',
            content: [
                'Cụm đồng hồ kỹ thuật số 8 inch',
            ],
        },
        {
            title: 'Hệ thống giải trí trên ô tô',
            content: [
                'Màn hình LED dọc 10 inch với SYNC®4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
            ],
        },
        {
            title: 'Ghế xe',
            content: [
                'Ghế nỉ',
                'Ghế lái chỉnh tay 6 hướng',
            ],
        },
        {
            title: 'Thùng hàng phía sau & các trang bị khác của xe',
            content: [
                'Tích hợp bậc lên xuống thùng hàng',
                'Tích hợp tấm bảo vệ thành thùng hàng',
                'Lót thùng hàng',
                'Nắp cuộn thùng hàng',
            ],
        },
    ];
    const rangerSport = [
        {
            title: 'Động cơ xe & Hộp số',
            content: [
                'Single Turbo Diesel 2.0L i4 TDCi',
                '170 (125 KW) / 3500',
                '405 Nm/ 1750-2500 rpm',
                'Số tự động 6 cấp',
            ],
        },
        {
            title: 'Hệ thống dẫn động của xe',
            content: [
                'Dẫn động hai cầu chủ động',
            ],
        },
        {
            title: 'Lưới tản nhiệt & Cụm đèn pha phía trước xe',
            content: [
                'Lưới tản nhiệt mạ crôm mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED hình chữ C',
                'Đèn sương mù',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 18 inch',
            ],
        },
        {
            title: 'Khoang lái xe',
            content: [
                'Cụm đồng hồ kỹ thuật số 8 inch',
                'Khởi động bằng nút bấm với Chìa khóa thông minh',
            ],
        },
        {
            title: 'Hệ thống giải trí trên ô tô',
            content: [
                'Màn hình LED dọc 10 inch trang bị SYNC®4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
                'Sạc không dây',
            ],
        },
        {
            title: 'Ghế xe',
            content: [
                'Ghế Da Vinyl',
                'Ghế lái chỉnh tay 6 hướng',
            ],
        },
        {
            title: 'Thùng hàng phía sau & các trang bị khác của xe',
            content: [
                'Tích hợp bậc lên xuống thùng hàng',
                'Tích hợp tấm bảo vệ thành thùng hàng',
            ],
        },
    ];
    const rangerXls = [
        {
            title: 'Động cơ xe & Hộp số',
            content: [
                'Single Turbo Diesel 2.0L i4 TDCi',
                '170 (125 KW) / 3500',
                '405 Nm/ 1750-2500 rpm',
                'Số tự động 6 cấp hoặc 6 số tay',
            ],
        },
        {
            title: 'Hệ thống dẫn động của xe',
            content: [
                'Dẫn động hai cầu chủ động hoặc một cầu chủ động',
            ],
        },
        {
            title: 'Lưới tản nhiệt & Cụm đèn pha phía trước xe',
            content: [
                'Lưới tản nhiệt mạ crôm mang ADN thiết kế đặc trưng Ford toàn cầu với cụm đèn pha LED hình chữ C',
                'Đèn sương mù',
            ],
        },
        {
            title: 'Bánh xe',
            content: [
                'Mâm xe hợp kim 16 inch',
            ],
        },
        {
            title: 'Khoang lái xe',
            content: [
                'Cụm đồng hồ kỹ thuật số 8 inch',
            ],
        },
        {
            title: 'Hệ thống giải trí trên ô tô',
            content: [
                'Màn hình LED dọc 10 inch với SYNC®4',
                'Kết nối không dây với Apple CarPlay® và Android AutoTM',
            ],
        },
        {
            title: 'Ghế xe',
            content: [
                'Ghế nỉ',
                'Ghế lái chỉnh tay 6 hướng',
            ],
        },
        {
            title: 'Thùng hàng phía sau & các trang bị khác của xe',
            content: [
                'Tích hợp bậc lên xuống thùng hàng',
                'Tích hợp tấm bảo vệ thành thùng hàng',
            ],
        },
    ];
    const mustangMachE = [
        {
            title: 'Vận hành',
            content: [
            'Quãng đường vận hành (WLTP): 550 km',
            'Công suất cực đại: 395 Ps',
            'Mô men xoắn cực đại: 676 Nm',
            'Dẫn động 4 bánh',
            'Dung lượng pin: 87 kWh',
            'Chuẩn sạc CCS2',
            ],
        },
        {
            title: 'Thiết kế bánh xe',
            content: [
            'Vành hợp kim 19″ với hoạt tiết thiết kế độc đáo',
            'Cùm phanh sơn đỏ nổi bật',
            ],
        },
        {
            title: 'Ngoại thất',
            content: [
            'Hệ thống đèn chiếu sáng Projector LED với tính năng Đèn Pha Tự động',
            ],
        },
        {
            title: 'Nội thất',
            content: [
            'Cửa sổ trời toàn cảnh bằng kính',
            'Ghế da điều chỉnh điện 8 hướng với chỉ khâu màu đỏ',
            'Đèn nội thất nhiều màu',
            'Chân ga và bậc lên xuống ốp kim loại',
            'Ghế gập 60/40',
            '2 điểm gắn ghế ISOFIX',
            ],
        },
        {
            title: 'Công nghệ',
            content: [
            'Màn hình cảm ứng đa năng 15.5 inch',
            'Bảng đồng hồ trung tâm 10.2 inch',
            'Hệ thống loa 10 Bang & Olufsen kèm subwoofer',
            'Kết nối không dây Apple CarPlay® và Android Auto™',
            'Sạc không dây',
            'Hệ Điều hành SYNC 4A',
            'Camera 360°',
            'Tương thích FordPass',
            ],
        },
        {
            title: 'Hỗ trợ Người Lái',
            content: [
            'Cảnh báo Điểm mù (BLIS) và Cảnh báo Phương tiện Cắt Ngang',
            'Hỗ trợ trước va chạm với phanh khẩn cấp tự động (AEB)',
            'Hỗ trợ Phanh khi Lùi',
            'Hỗ trợ Giữ phanh Sau Va chạm',
            'Kiểm soát Tốc độ Tự động Thông minh',
            'Hỗ trợ Đánh lái Tránh Va chạm',
            ],
        },
    ];


    useEffect(() => {
        switch (name) {
            case 'ford-territory-titanium-x':
                setAccordionData(teritoryTitaniumX);
                break;
            case 'ford-territory-sport':
                setAccordionData(teritorySport);
                break;
            case 'ford-territory-titanium':
                setAccordionData(teritoryTitanium);
                break;
            case 'ford-territory-trend':
                setAccordionData(teritoryTrend);
                break;
            case 'ford-everest-platinum':
                setAccordionData(everestPlatinum);
                break;
            case 'ford-everest-titanium':
                setAccordionData(everesttiatinum);
                break;
            case 'ford-everest-titanium20':
                setAccordionData(everesttiatinum20);
                break;
            case 'ford-everest-sport':
                setAccordionData(everestSport);
                break;
            case 'ford-everest-ambiente':
                setAccordionData(everestAmbiente);
                break;
            case 'ford-ranger-raptor':
                setAccordionData(rangerRaptor);
                break;
            case 'ford-ranger-stormtrak':
                setAccordionData(rangerStormtrak);
                break;
            case 'ford-ranger-wildtrak':
                setAccordionData(rangerWiltrak);
                break;
            case 'ford-ranger-sport':
                setAccordionData(rangerSport);
                break;
            case 'ford-ranger-xls-plus':
                setAccordionData(rangerXlsPlus);
                break;
            case 'ford-ranger-xls':
                setAccordionData(rangerXls);
                break;
            case 'ford-mustang-mach-e-premium-awd':
                setAccordionData(mustangMachE);
                break;
            default:
                setAccordionData([])
        }
    }, [name]);

    return (
        <div className="accordion">
            <style>{accordionStyles}</style>
            {accordionData.map((item) => (
                <AccordionItem
                    key={item.title}
                    title={item.title}
                    content={item.content}
                    isExpanded={expandedItems.includes(item.title)}
                    onToggle={() => handleToggle(item.title)}
                />
            ))}
        </div>
    );
}

export default SimpleAccordion;